import GetAlertsBlock from './GetAlertsBlock';
export default GetAlertsBlock;
